// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Medna Data Systems – Production URL
  webServiceURL: "https://" + window.location.hostname + ":7444",

  // Test System URL (uncomment when needed)
  // webServiceURL: "https://docchoice.com:8202",

  brandName: "Medna Data Systems",
  supportEmail: "support@medna.com",
}
